import { OptionGroup } from '@joor/design-system'
import { useSelector } from 'react-redux'

import { ShippingAddress } from '__generated__/atlas-types'

import { isAccountTypeBrand as isAccountTypeBrandSelector } from 'store/currentUser/selectors'

import { getShippingAddressOptions } from '../../Forms/ShippingAddressForm/shippingAddressForm.utils'
import { OptionsRecord, getAddressesOptionGroup } from '../../Forms/forms.utils'
import { RetailerInfo } from './useAddressModalData'
import { OrderBillingShippingData } from 'features/Orders/Review/components/Overview/components/AddressesWidget/addressesWidget.queries'

type UseShippingOptionsParams = {
  shippingAddresses?: ShippingAddress[]
  orderShipping?: OrderBillingShippingData['shipping']
  retailerInfo?: RetailerInfo
}

export function useShippingOptions({
  shippingAddresses = [],
  orderShipping,
  retailerInfo: { primaryLocation, locations } = {
    primaryLocation: undefined,
    locations: [],
  },
}: UseShippingOptionsParams) {
  const isAccountTypeBrand = useSelector(isAccountTypeBrandSelector)
  const addressOptionsData: OptionsRecord = getShippingAddressOptions({
    shippingAddresses,
    primaryLocation,
    retailerLocations: locations,
    shipping: orderShipping,
    isAccountTypeBrand,
  })

  const addressesOptionGroup: OptionGroup[] = getAddressesOptionGroup(
    isAccountTypeBrand,
    addressOptionsData,
  )

  return {
    aggregatedShippingOptions: addressOptionsData.aggregateOptions,
    shippingAddressesOptionGroup: addressesOptionGroup,
  }
}
